export const LogikFormItemErrors = ({
    errors,
    errorsLogikName,
}: {
    errors: React.ReactNode[];
    errorsLogikName?: string[];
}): JSX.Element => {
    return (
        <div className='antd-custom-form-item-error-container'>
            {errors?.map((e, i) => (
                <div className='antd-custom-form-item-error-msg' key={i}>
                    {e}
                </div>
            ))}
            {errors.length == 0 &&
                errorsLogikName?.map((e, i) => (
                    <div className='antd-custom-form-item-error-msg' key={i}>
                        {e}
                    </div>
                ))}
        </div>
    );
};
